import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd, { message } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './style.css'
import App from './App.vue'
import router from './router';
import { checkSecurityDev } from './utils/security'
import { initializeShopifyAuth } from './utils/shopifyAuth'

// 在应用启动前进行安全检查
checkSecurityDev()

// 初始化Shopify认证参数
initializeShopifyAuth()

// 同时最多只显示一条 message，避免保存校验/接口失败时 toast 叠多条
message.config({ maxCount: 1 })

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(Antd);
app.mount('#app');
